
const getCountryISO2 = require("country-iso-3-to-2");

export default class Customer {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.dob = jsonResponse["dob"];
        this.firstName = jsonResponse["first-name"];
        this.lastName = jsonResponse["last-name"];
        this.gender = jsonResponse["gender"];
        this.idNumber = jsonResponse["id-number"];
        this.idType = jsonResponse["id-type"];
        this.countryCode = jsonResponse["country-code"];
        this.countryName = jsonResponse["country-name"];
        this.msisdnValue = jsonResponse["msisdn"];
        this.emailAddress = jsonResponse["email-address"];
        this.registrationId = jsonResponse["registration-id"];
        this.approvalStatus = jsonResponse["approval-status"];
        this.hasActiveBankCard = jsonResponse["has-active-bank-card"];

        this.fullName = this.firstName + " " + this.lastName;

        this.countryISO2 =  getCountryISO2(this.countryCode).toLowerCase()
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["id"] = obj.id;
        jsonObj["dob"] = obj.dob;
        jsonObj["first-name"] = obj.firstName;
        jsonObj["last-name"] = obj.lastName;
        jsonObj["gender"] = obj.gender;
        jsonObj["id-number"] = obj.idNumber;
        jsonObj["id-type"] = obj.idType;
        jsonObj["country-code"] = obj.countryCode;
        jsonObj["country-name"] = obj.countryName;
        jsonObj["msisdn"] = obj.msisdnValue;
        jsonObj["registration-id"] = obj.registrationId;
        jsonObj["approval-status"] = obj.approvalStatus;

        return jsonObj;
    };
}
